<template>
  <v-flex class="settings" data-qa="settings-flex-00do3n">
    <Loader v-show="loaderEnabled"/>
    <v-layout wrap class="ml-2 settings--gradientBGposition" data-qa="settings-layout-phsfz">
      <v-flex
        xs12
        sm12
        md12
        lg12
        xl12
        :style="{ background: dashboardGradient, height: '180px' }"
       data-qa="settings-flex-kiq9go">
        <v-container class="settings--title-padding" data-qa="settings-container-5gf93e">
          <v-flex xs12 sm12 md12 lg12 xl12 data-qa="settings-flex-q45t2">
            <v-row no-gutters justify="center" data-qa="settings-row-wway3">
              <v-layout row wrap class="pb-2" data-qa="settings-layout-dg89bo">
                <v-flex xs9 sm9 md9 lg9 xl9 class="pt-4 pl-2" data-qa="settings-flex-8f68xg">
                  <v-row no-gutters data-qa="settings-row-joqkiu">
                    <font class="text-h5 font-weight-light white--text">
                      {{ $t("settings.settingsPage.title") }}</font
                    >
                  </v-row>
                </v-flex>
              </v-layout>
            </v-row>
          </v-flex>
        </v-container>
      </v-flex>
    </v-layout>
    <v-flex xs12 sm12 md12 lg10 xl10 class="pl-2 settings--overlayCardFlex" data-qa="settings-flex-apdeqd">
      <v-layout row wrap class="pl-2" data-qa="settings-layout-dnxkjj">
        <v-flex xs12 sm12 md12 lg9 xl9 data-qa="settings-flex-30wiy7">
          <v-container data-qa="settings-container-2ye13h">
            <!-- Marketing & Communication -->
            <v-row v-if="enableMarketingAndCommunicationsOption && isEditPreferencePermitted" no-gutters justify="start" order-xs-1 data-qa="settings-row-g1mbw8">
              <v-flex xs12 sm12 md12 lg12 xl12 v-if="customerData" data-qa="settings-flex-aoxst">
                <div
                  v-for="(item, key, index) in declarationAndConsent"
                  :key="index"
                 :data-qa="`settings-div-yp7k49-${index}`">
                  <v-card :data-qa="`settings-card-k76nb-${index}`">
                    <v-card-text class="pl-4" :data-qa="`settings-card-text-2pzf5d-${index}`">
                      <span :data-qa="`settings-span-uh93ei-${index}`">
                        <font
                          :color="darkColor"
                          class="text-h6 font-weight-light pt-2"
                          >{{
                            $t(
                              `settings.settingsPage.subtitle.marketingChannels`
                            )
                          }}</font
                        >
                      </span>
                      <v-layout row wrap :data-qa="`settings-layout-eux49j-${index}`">
                        <v-flex class="pt-0" xs12 sm12 md12 lg12 xl12 :data-qa="`settings-flex-rhi8x7-${index}`">
                          <v-flex class="pt-3" :data-qa="`settings-flex-o3e5yq-${index}`">
                            <font class="font-weight-bold">{{
                              $t("settings.settingsPage.subLabel.consolidatedStatement")
                            }}</font>
                            <v-layout row wrap class="pa-0" :data-qa="`settings-layout-5w6kp-${index}`">
                              <v-flex
                                v-for="(option, idx) in item.options"
                                :key="idx"
                                class="pa-0"
                                xs12
                                sm12
                                md6
                                lg6
                                xl6
                               :data-qa="`settings-flex-o07n76-${index}-${idx}`">
                                <v-checkbox
                                  v-model="option.isChecked"
                                  @change.capture="
                                    handleConsent(
                                      {
                                        key,
                                        selectedOption: option.value,
                                        index,
                                        digitalChannel: true,
                                      },
                                      $event
                                    )
                                  "
                                  :label="$t(`settings.settingsPage.settingsOptionLabels.${option.value}`)"
                                  :color="secondaryColor"
                                  :data-qa="`checkbox-child-${index}-${idx}`"
                                  class="hidePadding"
                                ></v-checkbox>
                              </v-flex>
                            </v-layout>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions class="pa-2 px-4 pb-4" :data-qa="`settings-card-actions-c1gbq8-${index}`">
                      <v-btn
                        @click="onMarketingChanges"
                        :color="primaryColor"
                        class="white--text text-capitalize py-2 px-4"
                        :data-qa="`settings-btn-uoxfqf-${index}`">
                      {{ $t("settings.settingsPage.saveButton") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-flex>
            </v-row>

            <!-- Statements -->
            <v-row v-if="enableConsolidatedStatementOption && (showOptForConsolidatedStatements || showOptForStatementByPost)" no-gutters justify="start" class="py-5" order-xs-2 data-qa="settings-row-qiroxl">
              <v-flex xs12 sm12 md12 lg12 xl12 v-if="customerData" data-qa="settings-flex-vqv94a">
                <div
                  v-for="(item, key, index) in declarationAndConsent"
                  :key="index"
                 :data-qa="`settings-div-dpv6m-${index}`">
                  <v-card :data-qa="`settings-card-phr27-${index}`">
                    <v-card-text class="pl-4" :data-qa="`settings-card-text-yihh95-${index}`">
                      <span :data-qa="`settings-span-47xiqc-${index}`">
                        <font
                          :color="darkColor"
                          class="text-h6 font-weight-light pt-2"
                          >{{
                            $t(
                              `settings.settingsPage.subtitle.consolidatedStatement`
                            )
                          }}</font
                        >
                      </span>
                      <v-layout v-if="showOptForConsolidatedStatements" row wrap :data-qa="`settings-layout-9780lh-${index}`">
                        <v-flex class="pt-0" xs12 sm12 md12 lg12 xl12 :data-qa="`settings-flex-sg71je-${index}`">
                          <v-flex class="pt-3" :data-qa="`settings-flex-g9w8m-${index}`">
                            <font class="font-weight-bold">{{
                              $t("settings.settingsPage.subLabel.optConsolidatedStatement")
                            }}</font>
                            <v-layout row wrap class="pa-0" :data-qa="`settings-layout-sa1n7i-${index}`">
                              <v-radio-group
                                v-model="showOptInStatement"
                                row
                                :data-qa="`settings-radio-group-xc1sb3a-${index}`">
                                <v-radio
                                  :label="$t('settings.settingsPage.yes')"
                                  :value="true"
                                  :color="secondaryColor"
                                  :data-qa="`settings-radio-1jmirc-${index}`"></v-radio>
                                <v-radio
                                  :label="$t('settings.settingsPage.no')"
                                  :value="false"
                                  :color="secondaryColor"
                                  :data-qa="`settings-radio-lxba5i-${index}`"></v-radio>
                              </v-radio-group>
                            </v-layout>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                       <!-- Customization to disable the statement to be sent by Post  -->
                      <v-layout v-if="showOptForStatementByPost&&enableReceiveStatementByPostOption" row wrap :data-qa="`settings-layout-74n5-${index}`">
                        <v-flex class="pt-0" xs12 sm12 md12 lg12 xl12 :data-qa="`settings-flex-re3i0l-${index}`">
                          <v-flex class="pt-3" :data-qa="`settings-flex-by7vn9-${index}`">
                            <font class="font-weight-bold">{{
                              $t("settings.settingsPage.subLabel.marketingChannels")
                            }}</font>
                            <v-layout row wrap class="pa-0" :data-qa="`settings-layout-qjyxd-${index}`">
                              <v-radio-group
                                v-model="isCStatementRequiredViaPost"
                                @change="
                                  handleCStatements(isCStatementRequiredViaPost)
                                "
                                row
                                :data-qa="`settings-radio-group-mbm91m-${index}`">
                                <v-radio
                                  :label="$t('settings.settingsPage.yes')"
                                  :value="true"
                                  :color="secondaryColor"
                                  :data-qa="`settings-radio-dlylv9-${index}`"></v-radio>
                                <v-radio
                                  :label="$t('settings.settingsPage.no')"
                                  :value="false"
                                  :color="secondaryColor"
                                  :data-qa="`settings-radio-9ylkn-${index}`"></v-radio>
                              </v-radio-group>
                            </v-layout>
                            <v-row class="pa-0 pl-3" :data-qa="`settings-row-51x5er-${index}`">
                              <v-alert icon="mdi-information-outline" class="v-alert--info" :data-qa="`settings-alert-rvp6nt-${index}`">
                                <font class="body-2 font-weight-regular">{{
                                  $t("settings.settingsPage.subLabel.marketingChannelsAlert")
                                }}</font>
                              </v-alert>
                            </v-row>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions class="pa-2 px-4 pb-4" :data-qa="`settings-card-actions-y4cgs-${index}`">
                      <v-btn
                        @click="onConsolidatedStatementsChanges"
                        :color="primaryColor"
                        class="white--text text-capitalize py-2 px-4"
                        :data-qa="`settings-btn-tbyhm9-${index}`">
                        {{ $t("settings.settingsPage.saveButton") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </div>
              </v-flex>
            </v-row>

            <!-- Multi Language -->
            <v-row v-if="enableLanguageSelection" no-gutters justify="start" class="py-5" order-xs-2 data-qa="settings-row-ilnxsn">
              <v-flex xs12 sm12 md12 lg12 xl12 v-if="customerData" data-qa="settings-flex-4utao">
                  <v-card data-qa="settings-card-5l7av">
                    <v-card-text class="pl-4" data-qa="settings-card-text-hphta">
                      <span data-qa="settings-span-nt9j8">
                        <font
                          :color="darkColor"
                          class="text-h6 font-weight-light pt-2"
                          >{{
                            $t(
                              `settings.settingsPage.subtitle.preferredLanguage`
                            )
                          }}</font
                        >
                      </span>
                      <v-layout row wrap data-qa="settings-layout-v57ogj">
                        <v-flex class="pt-0" xs12 sm12 md12 lg12 xl12 data-qa="settings-flex-ekn7r8">
                          <v-flex class="pt-3" data-qa="settings-flex-9j80i">
                            <v-layout row wrap class="pa-0" data-qa="settings-layout-8oedni">
                              <v-radio-group
                                v-model="preferredLanguage"
                                row
                               data-qa="settings-radio-group-5eijui">
                              <v-flex
                                v-for="(item, i) in availableLocaleList"
                                :key="item.internalCode"
                                class="pa-0"
                                xs12
                                sm12
                                md6
                                lg6
                                xl6
                                :data-qa="`settings-flex-2j0v8-${i}`"
                              >
                                <v-radio
                                  :label="item.localeName"
                                  :value="item.internalCode"
                                  :color="secondaryColor"
                                  :data-qa="`settings-radio-w74qna-${i}`"></v-radio>
                              </v-flex>
                              </v-radio-group>
                            </v-layout>
                          </v-flex>
                        </v-flex>
                      </v-layout>
                    </v-card-text>
                    <v-card-actions class="pa-2 px-4 pb-4" data-qa="settings-card-actions-lvew04">
                      <v-btn
                        @click="onSelectedLanguageChanges"
                        :color="primaryColor"
                        class="white--text text-capitalize py-2 px-4"
                       data-qa="settings-btn-aaa5k9">
                      {{ $t("settings.settingsPage.saveButton") }}
                      </v-btn>
                    </v-card-actions>
                  </v-card>
              </v-flex>
            </v-row>
          </v-container>
        </v-flex>
      </v-layout>
    </v-flex>
    <!-- OTP Section -->
    <Modal
      v-if="(enableOTPForStatements || enableOTPForMarketingCommunication || enableOTPForMultiLanguage) && showOTPScreen"
      :config="modalConfig.otp"
      @cancel="onOtpModalClose"
    >
      <span slot="modalContent" data-qa="settings-span-h51mfq">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <!-- Success Modal -->
     <Modal
      v-if="showSuccessModal"
      :config='computedModalConfig'
      @btn1Action="onSuccessModalClose()">
    </Modal>
  </v-flex>
</template>

<script>
import '@/styles/pages/settings.scss'
import preload from '@/util/preload'
import store from '@/core/store'
import event from '@/util/event'
import CommonService from '@/service/commonService.js'
import OtpInput from '@/components/common/OtpInput.vue'
import { loadLanguage } from '@/plugins/vueI18n'
import Loader from '../../components/common/Loader.vue'

export default {
  name: 'Settings',
  components: {
    Loader,
    OtpInput,
    Modal: () => import('@/components/common/Modal.vue')
  },
  data () {
    return {
      loaderEnabled: false,
      amendResponse: undefined,
      isCStatementRequired: 'No',
      isCStatementRequiredViaPost: null,
      declarationAndConsent: this.$appSettings.consentDeclarationContents,
      availableLocaleList: this.$appSettings.localizationAndLanguageSettings.availableLocaleList,
      enableLanguageSelection: this.$appSettings.defaultConfigurations.settingsScreen.enableLanguageSelection,
      enableOTPForMarketingCommunication: this.$appSettings.defaultConfigurations.enableOTPForSettingsScreen.enableOTPForMarketingCommunication,
      enableOTPForStatements: this.$appSettings.defaultConfigurations.enableOTPForSettingsScreen.enableOTPForStatements,
      enableOTPForMultiLanguage: this.$appSettings.defaultConfigurations.enableOTPForSettingsScreen.enableOTPForMultiLanguage,
      enableConsolidatedStatementOption: this.$appSettings.defaultConfigurations.settingsScreen.enableConsolidatedStatementOption,
      enableMarketingAndCommunicationsOption: this.$appSettings.defaultConfigurations.settingsScreen.enableMarketingAndCommunicationsOption,
      enableReceiveStatementByPostOption:this.$appSettings.defaultConfigurations.settingsScreen.enableReceiveStatementByPostOption,
      consentForMarketing: false,
      showSuccessModal: false,
      setChannelOnce: false,
      showOTPScreen: false,
      isAmendMarketing: false,
      isAmendLanguage: false,
      marketingChannels: {},
      appConsent: {},
      marketingChannelsDetails: {},
      showOptInStatement: false,
      preferredLanguage: '',
      statementMedium: null,
      customerData: '',
      modalConfig: {
        otp: {
          enabled: false,
          persistent: true,
          enableSave: true,
          close: true,
          saveButton: '',
          outlinedSaveBtn: false,
          title: this.$t('otp.toolBarTitle'),
          width: 400
        }
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations.otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      isEditPreferencePermitted: false,
      showOptForConsolidatedStatements: false,
      showOptForStatementByPost: false,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess
    }
  },
  computed: {
    computedModalConfig () {
      return {
        enabled: true,
        title: this.modalTitle,
        body: this.$t('settings.settingsPage.modalSubtitle'),
        persistent: true,
        btn1Label: this.$t('common.okay'),
        width: 500
      }
    },
    modalTitle () {
      if (this.isAmendMarketing) {
        return this.$t('settings.settingsPage.marketingAmendSuccessMsg')
      } else if (this.isAmendLanguage) {
        return this.$t('settings.settingsPage.languageAmendSuccessMsg')
      } else {
        return this.$t('settings.settingsPage.statementAmendSuccessMsg')
      }
    }
  },
  created () {
    this.getCustomerData()
    // Fetch Permissions for SME Users
    const permissions = store.getters['profileStore/profileData']?.permissions
    this.isEditPreferencePermitted = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('EDIT_PREFERENCE') : true
    this.showOptForConsolidatedStatements = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('OPT_FOR_CONSOLIDATED_STATEMENTS') : true
    this.showOptForStatementByPost = (this.isSmeLogin && this.enableRoleBasedAccess) ? permissions?.includes('OPT_FOR_STATEMENT_BY_POST') : true
    event.$on('IS_OTP_VALID', (valid) => {
      if (valid && (this.enableOTPForStatements || this.enableOTPForMarketingCommunication) && this.showOTPScreen) {
        this.modalConfig.otp.enabled = false

        if (this.isAmendMarketing) {
          this.amendCustomerDetails({
            preferences: {
              ...this.marketingChannelsDetails
            }
          })
        } else if (this.isAmendLanguage) {
          this.amendCustomerDetails({
            preferences: {
              preferredLanguage: this.preferredLanguage
            }
          })
        } else {
          this.amendCustomerDetails({
            isConsolidateStatementRequired: this.showOptInStatement,
            preferences: {
              preferredStatementChannel: this.statementMedium
            }
          })
        }
      }
    })
    event.$on('OTP_RESENT', (val) => {
      this.modalConfig.otp.enableSave = true
    })
  },
  methods: {
    get: (k) => JSON.parse(sessionStorage.getItem(k)),
    async getCustomerData () {
      const { get } = this
      const isSmeLogin = get('isSmeLogin') || false
      const customerCode = get('customerCode') || ''

      try {
        this.customerData = await preload.getCustomerDetails(isSmeLogin ? customerCode : get('username'))
        if (this.customerData) {
          this.setMarketingChannelsData()
          this.setConsolidatedStatement()
          this.setPreferredLanguage()
        }
      } catch (e) {
        console.log(e)
      }
    },
    onOtpModalClose (type = undefined) {
      this.modalConfig.otp.enabled = false
      this.modalConfig.otp.enableSave = true
      this.showOTPScreen = false
      if (type !== 'onComplete') {
        // this.setMarketingChannelsData()
        this.setConsolidatedStatement()
      }
    },
    getTickIcon () {
      return this.getSvgIconSrc('Tick')
    },
    setConsolidatedStatement () {
      const { isConsolidateStatementRequired, isConsolidateStatementRequiredViaPost } = store.getters[
        'profileStore/profileData'
      ].customerDetails
      this.showOptInStatement = isConsolidateStatementRequired
      this.statementMedium = isConsolidateStatementRequiredViaPost
      switch (isConsolidateStatementRequiredViaPost) {
        case '003':
          this.isCStatementRequiredViaPost = true
          break
        case '002':
          this.isCStatementRequiredViaPost = false
          break
        default:
          this.isCStatementRequiredViaPost = null
          break
      }
    },
    setPreferredLanguage () {
      const localeDetails = store.getters['profileStore/profileData'].localeDetails
      this.preferredLanguage = localeDetails && localeDetails.internalCode ? localeDetails.internalCode : ''
    },
    setMarketingSubLabel (via) {
      return (via === 'SMS') ? 'SMS' : this.$t(`personalSettings.marketingPreferences.acceptConsentText.${via}`)
    },
    setMarketingChannelsData () {
      const { preferences } = store.getters[
        'profileStore/profileData'
      ].customerDetails
      this.consentForMarketing = preferences
      if (this.declarationAndConsent && this.declarationAndConsent.consentForMarketing && this.declarationAndConsent.consentForMarketing.options && this.declarationAndConsent.consentForMarketing.options[0] && this.declarationAndConsent.consentForMarketing.options[1]) {
        this.declarationAndConsent.consentForMarketing.options[0].isChecked = false
        this.declarationAndConsent.consentForMarketing.options[1].isChecked = false
      }
      if (
        this.consentForMarketing &&
        this.consentForMarketing.consentForMarketing
      ) {
        this.declarationAndConsent.consentForMarketing.isChecked = true
        const key = Object.values(this.consentForMarketing.marketingChannels)
        key.forEach((channel) => {
          if (channel) {
            const { channelName } = channel
            switch (channelName) {
              case 'SMS': this.declarationAndConsent.consentForMarketing.options[0].isChecked = true
                break
              case 'EMAIL': this.declarationAndConsent.consentForMarketing.options[1].isChecked = true
                break
              case 'TELEPHONE': this.declarationAndConsent.consentForMarketing.options[2].isChecked = true
                break
              case 'POST': this.declarationAndConsent.consentForMarketing.options[3].isChecked = true
                break
              default:
            }
          }
        })
      }
    },
    handleConsent ({ key, selectedOption, index, digitalChannel = false }, e) {
      let valid = false
      this.marketingChannelsDetails = {}
      const digitalChannelObj = (channelName) => ({
        channelName,
        channelDescription: this.channelName(channelName)
      })
      const filterTOS = (filterValue) =>
        Object.keys(this.declarationAndConsent).filter(
          (statement) => this.declarationAndConsent[statement][filterValue]
        )

      if (!this.setChannelOnce && this.consentForMarketing.marketingChannels) {
        this.consentForMarketing.marketingChannels.forEach((channel) => {
          const { channelName } = channel
          this.marketingChannels = Object.assign(this.marketingChannels, {
            [channelName]: digitalChannelObj(channelName)
          })
        })
        this.setChannelOnce = true
      }
      if (digitalChannel && e) {
        this.marketingChannels = Object.assign(this.marketingChannels, {
          [selectedOption]: digitalChannelObj(selectedOption)
        })
      } else if (digitalChannel && !e) {
        delete this.marketingChannels[selectedOption]
      } else {
        this.declarationAndConsent[key].isChecked = e
      }
      const marketingChannels = Object.values(this.marketingChannels)
      const acceptedTOS = Object.keys(this.declarationAndConsent).filter(
        (statement) =>
          this.declarationAndConsent[statement].isChecked &&
          this.declarationAndConsent[statement].mandatory
      )

      this.appConsent = Object.assign(this.appConsent, {
        [key]: e
      })
      if (acceptedTOS.length === filterTOS('mandatory').length) {
        this.appConsent = Object.assign(this.appConsent, {
          [key]: e
        })
        if (
          (this.declarationAndConsent[filterTOS('options').toString()]
            .isChecked &&
            Boolean(marketingChannels.length)) ||
          !this.declarationAndConsent[filterTOS('options').toString()].isChecked
        ) {
          valid = true
        }

        this.marketingChannelsDetails = {
          consentForMarketing: Boolean(marketingChannels.length),
          marketingChannels
        }
      } else {
        this.marketingChannelsDetails = {
          appConsent: '',
          marketingChannels: []
        }
      }
    },
    channelName (type) {
      let value = ''
      switch (type) {
        case 'SMS':
          value = 'Mobile'
          break
        case 'TELEPHONE':
          value = 'Telephone'
          break
        case 'POST':
          value = 'Post'
          break
        default:
          value = 'Email'
          break
      }
      return value
    },
    handleCStatements () {
      let value = null
      switch (this.isCStatementRequiredViaPost) {
        case true:
          value = '003'
          break
        case false:
          value = '002'
          break
        default:
          value = null
          break
      }
      this.statementMedium = value
    },
    storeStatements () {
      this.isAmendMarketing = false
      store.dispatch('profileStore/setProfileData', {
        isConsolidateStatementRequiredViaPost: this.statementMedium,
        isCStatementModified: true
      })
      store.dispatch('profileStore/setProfileData', {
        isConsolidateStatementRequired: this.showOptInStatement,
        isCStatementOpted: true
      })
    },
    onMarketingChanges () {
      this.isAmendMarketing = true
      this.$store.dispatch('profileStore/setProfileData', {
        marketingChannelsDetails: this.marketingChannelsDetails
      })
      if (this.enableOTPForMarketingCommunication) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.amendCustomerDetails({
          preferences: {
            ...this.marketingChannelsDetails
          }
        })
      }
    },
    onConsolidatedStatementsChanges () {
      this.storeStatements()
      if (this.enableOTPForStatements) {
        this.showOTPScreen = true
        this.modalConfig.otp.enabled = true
      } else {
        this.amendCustomerDetails({
          isConsolidateStatementRequired: this.showOptInStatement,
          preferences: {
            preferredStatementChannel: this.statementMedium
          }
        })
      }
    },
    onSelectedLanguageChanges () {
      if (this.preferredLanguage && this.preferredLanguage.length) {
        this.isAmendLanguage = true
        if (this.enableOTPForMultiLanguage) {
          this.showOTPScreen = true
          this.modalConfig.otp.enabled = true
        } else {
          this.amendCustomerDetails({
            preferences: {
              preferredLanguage: this.preferredLanguage
            }
          })
        }
      }
    },
    async amendCustomerDetails (params = null) {
      this.onOtpModalClose('onComplete')
      try {
        this.loaderEnabled = true
        this.amendResponse = await CommonService.amendCustomerDetails(params, 'settings')
        this.loaderEnabled = false
        if (this.amendResponse && this.amendResponse.partyId) {
          this.showSuccessModal = true
          if (this.isAmendLanguage && params?.preferences?.preferredLanguage) {
            await preload.getAvailableLocaleList(params?.preferences?.preferredLanguage)
            const partyPreferredLanguage = store.getters['profileStore/profileData'].preferredLanguage
            this.$i18n.locale = partyPreferredLanguage
            loadLanguage(this.$i18n.locale)
          }
        }
      } catch (e) {
        console.log(e)
      }
    },
    onSuccessModalClose () {
      const { get } = this
      const isSmeLogin = get('isSmeLogin') || false
      const customerCode = get('customerCode') || ''

      this.showSuccessModal = false
      // fetch customer details API call
      preload.getCustomerDetails(isSmeLogin ? customerCode : get('username'))
    }
  },
  watch: {
    showOTPScreen () {
      if ((this.enableOTPForStatements || this.enableOTPForMarketingCommunication) && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  }
}
</script>
